const MapSetControls = () => (
	<div>
		<h4>Map set controls</h4>
		<p>Two inter-linked windows / slider switch</p>
		<p>Zoom in / zoom out (works also using a mouse slider)</p>
	</div>
);

export default MapSetControls;
